export const OBJECT_NAME = {
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
  MANAGE: "manage",
  REQUEST_REVIEW: "request_review",
} as const;
